function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.002 4.483v1.404c.031.293-.055.597-.26.822a.854.854 0 01-1.285 0L.467 4.365A.912.912 0 01.3 4.235l-.034-.027A1.044 1.044 0 010 3.5c0-.111.016-.223.05-.329a.972.972 0 01.481-.587L3.457.292a.854.854 0 011.285 0c.205.224.291.528.26.82v1.381h14.09c.501 0 .908.446.908.995 0 .55-.407.995-.909.995H5.001z",
  fill: "#fff"
});

var SvgBackSmall = function SvgBackSmall(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 7,
    viewBox: "0 0 20 7",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='20' height='7' viewBox='0 0 20 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.00177 4.48327V5.88726C5.03348 6.17966 4.94698 6.48443 4.74225 6.70869C4.38753 7.09729 3.81225 7.09708 3.45726 6.70823L0.467893 4.36626C0.408545 4.33021 0.352104 4.28632 0.299833 4.23459L0.266383 4.20839C0.087844 4.01283 -0.000952253 3.7562 7.70011e-06 3.49997C-0.000408936 3.38876 0.0160819 3.27748 0.0494791 3.17115C0.129456 2.91058 0.305269 2.6982 0.53106 2.5842L3.45726 0.291817C3.81225 -0.0970736 4.38753 -0.0972827 4.74225 0.291252C4.94698 0.515597 5.03348 0.82037 5.00177 1.11276V2.49321H19.0911C19.5931 2.49321 20 2.93871 20 3.4883C20 4.03783 19.5931 4.48327 19.0911 4.48327H5.00177Z' fill='white'/%3E %3C/svg%3E";
export { SvgBackSmall as ReactComponent };